import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import Table from '../../../../common/components/table'


export default function PageLayoutComponent ({setPageData,paginationData,additionButtons,rowData,columnDefs,onEdit}: any) {
  return (
    <>

<Table
    columnData={columnDefs}
    rowData={rowData}
    onEdit={onEdit}
    additionButtons={additionButtons}
    headingName="Layouts"
    paginationData={paginationData}
    setPageData={setPageData}
    />
        </>
  )
}